import { render, staticRenderFns } from "./paperInterviewDetail.vue?vue&type=template&id=3468884c&scoped=true&"
import script from "./paperInterviewDetail.vue?vue&type=script&lang=js&"
export * from "./paperInterviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./paperInterviewDetail.vue?vue&type=style&index=0&id=3468884c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3468884c",
  null
  
)

export default component.exports